export const MESSAGE_TYPES = {
  NEW: 'NEW',
  REPLY: 'REPLY',
  FORWARD: 'FORWARD',
} as const;
